import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { 
  Modal, Button, FormGroup,
  ControlLabel, FormControl, HelpBlock,
  Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import { indexOf, find, filter, isArray } from 'lodash';
// import CRMInstanceName from '.../../../../components/crm-instance-name';
// Import Actions
import { requestAddOrganizationUser, requestUpdateOrganizationUser } from '../../SetupActions';
import DateTimeDisplay from '../../../../components/date-time-display';
// Import Selectors
import { getUser } from '../../../Auth/AuthReducer';
import AuditLog from '../../../../components/audit-logs';

const BASE_ORGANIZATION_IDS = process.env.REACT_APP_BASE_ORGANIZATION_IDS || [];
class OrganizationUserButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    if (props.showModal) {
      this.open();
    }
  }

  componentDidMount() {
    this.mounted = true;
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  close() {
    this.props.reset();
    if (this.mounted) {
      this.setState({ showModal: false });
      this.props.onClose();
    }
  }

  open() {
    this.props.initialize({ ...this.props.user, has_active_account: !this.props.user.is_none_standard_user });
    this.setState({ showModal: true });
  }

  handleSubmit(data) {
    const { user, organization } = this.props;
    const isNew = user._id === undefined;
    const organizationId = organization._id;
    const params = { ...data, is_none_standard_user: !data.has_active_account };
    if (!params.is_none_standard_user) {
      params.is_synchronization_user = data.is_synchronization_user;
      delete params.username;
    }
    delete params.has_active_account;
    const action = isNew ? requestAddOrganizationUser(organizationId, params) : requestUpdateOrganizationUser(organizationId, user._id, params);
    return this.props.dispatch(action)
      .then(
        (result) => {
          if (isNew) {
            this.props.onAdd(result.user);
          } else {
            this.props.onUpdate(result.user);
          }
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          } else if (e.role) {
            e._error = e.role;
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, disabled, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...input} placeholder={label} type={type} disabled={submitting || disabled} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{(isArray(error) ? error.join(', ') : error)}</HelpBlock>}
      </FormGroup>
    );
  }

  renderModal() {
    const {
      handleSubmit, submitting, user, loginUser,
      error, selectedRole, organization, selectedHasActiveAccount, selectedOrganizationRole,
    } = this.props;
    const isNew = user._id === undefined;
    const disabled = (user.last_activity !== undefined && user.last_activity !== null) || user.logs > 0;
    const loginUserRole = loginUser.role;
    const orgDisplayName = organization !== undefined ? organization.display_name : 'their organization';
    const validRoles = [
      {
        label: 'Super Admin',
        value: 'superadmin',
        hint: `Super Admins have the right to add and remove other Super Admins,
          can add and remove Admins, can select and view any organization, and can delete an organization.`,
      },
      {
        label: 'Admin',
        value: 'admin',
        hint: `Admins can add other Admins, add and remove TruVoice by Corporate Visions users,
          assign organization view rights to TruVoice by Corporate Visions users, add and remove Standard Users,
          and view any organization in TruVoice Automation.`,
      },
      {
        label: 'PI',
        value: 'pi',
        hint: `PI Users can add new organizations to TruVoice Automation
          and add and remove standard users for those organizations.`,
      },
      {
        label: 'Standard User',
        value: 'user',
        hint: `Standard users will have access to
          ${orgDisplayName} data in TruVoice Automation.`,
      },
    ];

    const organizationRoles = [
      {
        label: 'Admin',
        value: 'admin',
        hint: `Organization Admins can see all data for ${orgDisplayName} and add and remove users for ${orgDisplayName}.`,
      },
      {
        label: 'Manager',
        value: 'manager',
        hint: `Organization Managers can see all data for ${orgDisplayName}.`,
      },
      {
        label: 'Sales Representative',
        value: 'user',
        hint: `Sales Representatives can only view their own data for ${orgDisplayName}.`,
      },
    ];
    
    const selectedOrganizationRoleValue = find(organizationRoles, { value: selectedOrganizationRole });

    let roles = [];
    if (loginUserRole === 'superadmin') {
      roles = ['superadmin', 'admin', 'pi', 'user'];
    } else if (loginUserRole === 'admin') {
      roles = ['admin', 'pi', 'user'];
    } else if (loginUserRole === 'pi') {
      roles = ['user'];
    } else {
      roles = ['user'];
    }
    const selectedValue = find(validRoles, { value: selectedRole });
    const validRolesAfterFilter = filter(validRoles, validRole => indexOf(roles, validRole.value) >= 0);
    const showWelcomeEmail = isNew || !user.logs;
    const isBaseOrg = indexOf(BASE_ORGANIZATION_IDS, organization.organization_id) >= 0;
    const summaryTip = (
      <Tooltip id="summary-tip">
        <span>When this option is selected all personally identifying information will be anonymized or masked for the user.</span>
      </Tooltip>
    );
    const summaryIcon = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={summaryTip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );

    const activeTip = (
      <Tooltip id="summary-tip">
        <span>
          Select this option when the user will use their CRM account to log into TruVoice Automation. 
          Uncheck this option if the user will not be using a CRM account to access TruVoice Automation and instead will create a login using their email address and a password.
        </span>
      </Tooltip>
    );
    const activeIcon = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="right" overlay={activeTip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );

    const syncTip = (
      <Tooltip id="summary-tip">
        <span>
          Select this option if the user has CRM Admin rights, or you are certain they have enough CRM rights to authorize TruVoice Automation to sync with CRM.
        </span>
      </Tooltip>
    );
    const syncIcon = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={syncTip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );

    const emailTip = (
      <Tooltip id="summary-tip">
        <span>
          Selecting this option will cause TruVoice Automation to send the welcome email to the user when you click the save button.
          The welcome email contains instructions for the user to access TruVoice Automation based on how you have configured their access here
        </span>
      </Tooltip>
    );
    const emailIcon = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={emailTip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );


    return (
      <Modal show={this.state.showModal} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          {isNew && <Modal.Title>Add New User To {organization !== undefined ? organization.display_name : 'Organization'}</Modal.Title>}
          {!isNew && <Modal.Title>Edit User</Modal.Title>}
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            {error && <div className="alert alert-danger">{error}</div>}

            {disabled && user.last_activity !== null &&
              <div className="alert alert-success">
                <Fa name="info-circle" /> This user is already connected to TruVoice Automation&trade;.
                &nbsp;
                {user.last_activity !== null && <span>Last login: <DateTimeDisplay value={user.last_activity} format="shortWithTime" relative /></span>}
              </div>
            }

            <FormGroup>
              <div className="checkbox">
                {!disabled && isNew &&
                  <label>
                    <Field name="has_active_account" id="has_active_account" component="input" type="checkbox" />
                    &nbsp;User {(!selectedHasActiveAccount ? 'does not have' : 'has')} an active CRM account for <strong>{organization.display_name}</strong> {activeIcon}
                  </label>
                }
                {(disabled || !isNew) &&
                  <div>
                    {selectedHasActiveAccount &&
                      <div>
                        <Fa name="check-circle" className="text-success" /> This user has an active CRM account for <strong>{organization.display_name}</strong>
                      </div>
                    }
                    {!selectedHasActiveAccount &&
                      <div>
                        <Fa name="warning" className="text-warning" /> This user does not have an active CRM account for <strong>{organization.display_name}</strong>
                      </div>
                    }
                  </div>
                }
              </div>
            </FormGroup>
            
            <div className="row">
              <div className="col-xs-6">
                <Field name="first_name" type="text" component={this.renderField} label="First Name" />
              </div>
              <div className="col-xs-6">
                <Field name="last_name" type="text" component={this.renderField} label="Last Name" />
              </div>
            </div>

            <Field name="email" type="text" component={this.renderField} label="Email" />

            {!selectedHasActiveAccount && <Field name="username" type="text" component={this.renderField} label="Username" />}

            {isBaseOrg && validRolesAfterFilter.length > 1 && loginUser._id !== user._id && <div className="panel panel-default">
              <div className="panel-heading">
                Global Role:
              </div>
              <div className="panel-body">
                <FormGroup>
                  {validRolesAfterFilter.map(validRole => (
                    <span key={validRole.value}>
                      <label><Field name="role" component="input" type="radio" value={validRole.value} />{validRole.label}</label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    ))}
                </FormGroup>
                {selectedValue !== undefined && <div><small><Fa name="info-circle" /> {selectedValue.hint}</small></div>}

                {!isNew && <AuditLog label="User Global Role" subjectId={user._id} type="userRoleChanged" organization={organization} />}
              </div>
            </div>}

            {organizationRoles.length > 0 && (loginUser._id !== user._id || loginUserRole === 'superadmin' || loginUserRole === 'admin') && 
              <div className="panel panel-default">
                <div className="panel-heading">
                  Internal Role within {orgDisplayName}:
                </div>
                <div className="panel-body">
                  <FormGroup>
                    {organizationRoles.map(validRole => (
                      <span key={validRole.value}>
                        <label><Field name="organization_role" component="input" type="radio" value={validRole.value} />{validRole.label}</label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                      ))}
                  </FormGroup>
                  {selectedOrganizationRoleValue !== undefined && <div><small><Fa name="info-circle" /> {selectedOrganizationRoleValue.hint}</small></div>}
                </div>
              </div>
            }

            <FormGroup>
              <div className="checkbox">
                <label>
                  <Field name="is_restricted" id="is_restricted" component="input" type="checkbox" />
                  &nbsp;User will see anonymized data for <strong>{organization.display_name}</strong> {summaryIcon}
                </label>
              </div>
            </FormGroup>

            {selectedHasActiveAccount === true && organization.type !== 'azure' &&
              <FormGroup>
                <div className="checkbox">
                  <label>
                    <Field name="is_synchronization_user" id="is_synchronization_user" component="input" type="checkbox" />
                    &nbsp;User has necessary CRM rights to authorize <strong>{organization.display_name}</strong> to sync data with TruVoice Automation&trade;. {syncIcon}
                  </label>
                </div>
              </FormGroup>
            }
            {showWelcomeEmail &&
              <FormGroup>
                <div className="checkbox">
                  <label>
                    <Field name="invite" id="invite" component="input" type="checkbox" />
                    &nbsp;Send TruVoice Automation&trade; welcome email {emailIcon}
                  </label>
                </div>
              </FormGroup>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>
            {isNew &&
              <Button bsStyle="primary" disabled={submitting} type="submit">
                {!submitting && <span><Fa name="plus" /> Add</span>}
                {submitting && <span><Fa name="spinner" spin /> Adding</span>}
              </Button>
            }
            {!isNew &&
              <Button bsStyle="primary" disabled={submitting} type="submit">
                {!submitting && <span><Fa name="pencil" /> Update</span>}
                {submitting && <span><Fa name="spinner" spin /> Updating</span>}
              </Button>
            }
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const { user, disabled, size } = this.props;
    const isNew = user._id === undefined;
    return (
      <span>
        {this.renderModal()}
        <Button disabled={disabled} bsSize={size} onClick={this.open} bsStyle="primary">
          {isNew && <span><Fa name="plus" /> Add User</span>}
          {!isNew && <span><Fa name="edit" /> Edit</span>}
        </Button>
      </span>
    );
  }
}

const selector = formValueSelector('addOrganizationUser'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    loginUser: getUser(state),
    initialValues: { ...ownProps.user },
    selectedRole: selector(state, 'role'),
    selectedOrganizationRole: selector(state, 'organization_role'),
    selectedHasActiveAccount: selector(state, 'has_active_account'),
  };
}

OrganizationUserButton.propTypes = {
  initialize: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  size: PropTypes.string,
  user: PropTypes.object.isRequired,
  organization: PropTypes.shape({}).isRequired,
  selectedRole: PropTypes.string,
  loginUser: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  selectedHasActiveAccount: PropTypes.bool,
  selectedOrganizationRole: PropTypes.string,
  onClose: PropTypes.func,
  showModal: PropTypes.bool,
};
OrganizationUserButton.defaultProps = {
  onAdd: () => {},
  onUpdate: () => {},
  onClose: () => {},
  disabled: false,
  size: null,
  user: {
    role: 'user',
    is_restricted: false,
    organization_role: 'manager',
    invite: false,
  },
  showModal: false,
};

const AddOrganizationUserForm = reduxForm({
  form: 'addOrganizationUser',
})(OrganizationUserButton);

export default connect(mapStateToProps)(AddOrganizationUserForm);
